module.exports = __webpack_public_path__ + "static/Neiman_Marcus-Logo.wine-57b7a3f2eaa870a25729a45f2e0ce727.svg";